/* ============================================================
   BELLEPET Theme JS - Shopify-Adaption (v5.2 Entfernen-Button)
   Header/Footer via Liquid
   BPCart via Shopify Cart AJAX API
   v3: Nav dropdown auto-repositioning to prevent viewport overflow
   v4 (2026-08-12): Gratis-Versand-Schwelle im Cart-Drawer 49 -> 50 EUR
   v5 (2026-08-14): Add-on-Upsell im Cart-Drawer aus Kollektion
       'warenkorb-add-ons' (products.json), im Korb liegende ausgeblendet.
   v5.1 (2026-08-14): Karten-Layout mit grossem HINZUFUEGEN-Button
       (Vorlage: Screenshot Ben), horizontal scrollbar.
   v5.2 (2026-08-18): Expliziter 'Entfernen'-Button pro Warenkorb-Artikel
       (Kundenfeedback an Birte: Artikel nur ueber Minus entfernbar war
       zu versteckt). Setzt die Zeile per /cart/change.js auf Menge 0.
   v5.3 (2026-10-09): Burger/Drawer bis 1279 px (T27, wie nav-v2.css),
       Drawer-Thumbnails 160 px statt Original (T28), Karten-Button
       „+ Warenkorb“ ohne Formular (T15/T26), Hover tauscht auch alt (T13).
   ============================================================ */

function bp_icon(name){
  const p = {
    search:'<circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/>',
    user:'<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/>',
    bag:'<path d="M6 8h12l-1 12H7z"/><path d="M9 8a3 3 0 0 1 6 0"/>',
    menu:'<path d="M4 7h16M4 12h16M4 17h16"/>',
    close:'<path d="M6 6l12 12M18 6 6 18"/>',
    ig:'<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>',
    fb:'<path d="M14 8h2V5h-2c-2 0-3 1-3 3v2H9v3h2v6h3v-6h2l1-3h-3V8c0-.6.4-1 1-1z" fill="currentColor" stroke="none"/>'
  };
  return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${p[name]||''}</svg>`;
}
window.bp_icon = bp_icon;

/* ============================================================
   Nav v3 - Desktop Hover Mega + Mobile Drawer + auto-reposition
   ============================================================ */
function wireNav(){
  const nav    = document.getElementById('mainnav');
  const burger = document.getElementById('burger');
  const scrim  = document.getElementById('navscrim');
  if(!nav || !burger) return;
  const items  = Array.from(nav.querySelectorAll('.nav-item.has-mega'));
  const isMobile = () => window.matchMedia('(max-width:1279px)').matches; /* T27: wie nav-v2.css */
  let closeTimer;

  function positionMega(it){
    if(isMobile()) return;
    const mega = it.querySelector('.mega');
    if(!mega) return;
    mega.classList.remove('mega--right','mega--left');
    requestAnimationFrame(() => {
      const rect = mega.getBoundingClientRect();
      const vw = window.innerWidth;
      const margin = 12;
      if(rect.right > vw - margin){
        mega.classList.add('mega--right');
      } else if(rect.left < margin){
        mega.classList.add('mega--left');
      }
    });
  }

  const closeAll = (except)=> items.forEach(it=>{
    if(it!==except){ it.classList.remove('open'); it.querySelector('.nav-link')?.setAttribute('aria-expanded','false'); }
  });
  const open = (it)=>{
    clearTimeout(closeTimer); closeAll(it);
    it.classList.add('open');
    it.querySelector('.nav-link')?.setAttribute('aria-expanded','true');
    positionMega(it);
  };
  const close = (it)=>{ it.classList.remove('open'); it.querySelector('.nav-link')?.setAttribute('aria-expanded','false'); };

  items.forEach(it=>{
    const link = it.querySelector('.nav-link');
    it.addEventListener('mouseenter', ()=>{ if(!isMobile()) open(it); });
    it.addEventListener('mouseleave', ()=>{ if(!isMobile()) closeTimer=setTimeout(()=>close(it),140); });
    link.addEventListener('click', (e)=>{
      if(isMobile()){
        e.preventDefault();
        it.classList.contains('open') ? close(it) : open(it);
      }
    });
    it.addEventListener('focusin', ()=>{ if(!isMobile()) open(it); });
    it.addEventListener('focusout', (e)=>{ if(!isMobile() && !it.contains(e.relatedTarget)) close(it); });
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      items.forEach(it => { if(it.classList.contains('open')) positionMega(it); });
    }, 100);
  });

  document.addEventListener('keydown', e=>{ if(e.key==='Escape') closeAll(null); });
  document.addEventListener('click', e=>{ if(!nav.contains(e.target) && !isMobile()) closeAll(null); });

  const toggleDrawer = (on)=>{
    nav.classList.toggle('open',on); scrim?.classList.toggle('open',on);
    document.body.style.overflow = on ? 'hidden' : '';
    burger.setAttribute('aria-label', on ? 'Menü schließen' : 'Menü öffnen');
    if(!on) closeAll(null);
  };
  burger.addEventListener('click', ()=> toggleDrawer(!nav.classList.contains('open')));
  const navClose = document.getElementById('navclose');
  if(navClose) navClose.addEventListener('click', ()=> toggleDrawer(false));
  scrim?.addEventListener('click', ()=> toggleDrawer(false));
}

/* ============================================================
   BPCart - Slide-Drawer (+ v5.1 Add-on-Upsell mit Karten)
   ============================================================ */
const BPCart = (function(){
  const fmt = n => (n/100).toFixed(2).replace('.',',')+' €';
  let chrome = null;
  let currentCart = null;
  let addons = null;

  function ensure(){
    if(chrome) return;
    const wrap = document.createElement('div');
    wrap.innerHTML = `
      <div class="cart-scrim" id="cartScrim"></div>
      <aside class="cart-drawer" id="cartDrawer" role="dialog" aria-label="Warenkorb" aria-modal="true">
        <div class="cart-head"><h3>Warenkorb</h3><button class="cart-x" id="cartX" aria-label="Schließen">&times;</button></div>
        <div class="cart-body" id="cartBody"></div>
        <div class="cart-foot" id="cartFoot"></div>
      </aside>
      <style>
        .cart-addons{margin-top:18px;border-top:1.5px solid var(--line-soft,#e6e0d4);padding-top:14px}
        .ca-head{font-weight:800;font-size:.8rem;letter-spacing:.05em;text-transform:uppercase;color:var(--ink-2,#555);margin-bottom:10px}
        .ca-grid{display:flex;gap:10px;overflow-x:auto;padding-bottom:4px;-webkit-overflow-scrolling:touch;scrollbar-width:thin}
        .ca-card{flex:0 0 46%;min-width:130px;display:flex;flex-direction:column;background:var(--cream,#fff);border:1.5px solid var(--line-soft,#e6e0d4);border-radius:14px;overflow:hidden}
        .ca-card img{width:100%;aspect-ratio:1/1;object-fit:cover;background:var(--natur,#DED5C4);display:block}
        .ca-card .ca-noimg{width:100%;aspect-ratio:1/1;background:var(--natur,#DED5C4);display:flex;align-items:center;justify-content:center;font-size:26px}
        .ca-info{display:flex;flex-direction:column;gap:2px;padding:8px 10px 0;flex:1}
        .ca-name{font-size:.82rem;font-weight:700;line-height:1.25;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
        .ca-price{font-size:.82rem;color:var(--ink-2,#555);margin-top:2px}
        .ca-add{margin:8px;margin-top:10px;padding:10px 8px;border:0;border-radius:10px;background:var(--ink,#1a1a1a);color:#fff;font-family:inherit;font-weight:800;font-size:.72rem;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;transition:background .14s,opacity .14s}
        .ca-add:hover{background:var(--cognac,#C05A2C)}
        .ca-add:disabled{opacity:.5;cursor:default}
        .ci-remove{background:none;border:0;padding:6px 0 0;font-family:inherit;font-size:.78rem;font-weight:700;color:var(--ink-3,#8a8177);text-decoration:underline;text-underline-offset:2px;cursor:pointer;align-self:flex-start;transition:color .14s}
        .ci-remove:hover{color:var(--cognac,#C05A2C)}
      </style>`;
    document.body.appendChild(wrap);
    chrome = true;
    document.getElementById('cartScrim').addEventListener('click', close);
    document.getElementById('cartX').addEventListener('click', close);
    document.addEventListener('keydown', e=>{ if(e.key==='Escape') close(); });
  }

  async function loadAddons(){
    if(addons !== null) return addons;
    try{
      const r = await fetch('/collections/warenkorb-add-ons/products.json?limit=8',{headers:{'Accept':'application/json'}});
      if(!r.ok) throw new Error('addons http '+r.status);
      const j = await r.json();
      addons = (j.products||[]).map(p=>{
        const v = (p.variants && p.variants[0]) || null;
        let img = (p.images && p.images[0] && p.images[0].src) || '';
        if(img) img += (img.indexOf('?')>-1?'&':'?')+'width=320';
        return { pid: p.id, vid: v ? v.id : null, title: p.title, price: v ? Math.round(parseFloat(v.price)*100) : 0, img: img, available: v ? v.available !== false : false };
      }).filter(a=>a.vid && a.available !== false);
    }catch(e){ addons = []; }
    return addons;
  }

  async function fetchCart(){
    const r = await fetch('/cart.js',{headers:{'Accept':'application/json'}});
    currentCart = await r.json();
    if(addons === null){ try{ await loadAddons(); }catch(e){ addons = []; } }
    render();
    refresh();
    return currentCart;
  }

  function refresh(){
    const badge = document.getElementById('cartCount');
    if(badge && currentCart){
      badge.textContent = currentCart.item_count;
      badge.hidden = currentCart.item_count === 0;
    }
  }

  async function addVariant(variantId, quantity=1, properties={}){
    ensure();
    const r = await fetch('/cart/add.js',{
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: variantId, quantity, properties }] })
    });
    if(!r.ok){ console.warn('Cart add failed', await r.text()); return; }
    await fetchCart(); open();
  }

  async function updateLine(line, quantity){
    const r = await fetch('/cart/change.js',{
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ line, quantity })
    });
    if(r.ok){ currentCart = await r.json(); render(); refresh(); }
  }

  function render(){
    ensure();
    if(!currentCart) return;
    const body = document.getElementById('cartBody');
    const foot = document.getElementById('cartFoot');
    if(currentCart.item_count === 0){
      body.innerHTML = `<div class="cart-empty"><p>Dein Warenkorb ist noch leer.</p><a class="btn btn-primary" id="cartShop">Weiter stöbern</a></div>`;
      foot.innerHTML = '';
      document.getElementById('cartShop').addEventListener('click', close);
      return;
    }
    let html = currentCart.items.map((it,idx)=>{
      const props = it.properties && Object.entries(it.properties).filter(([k])=>!k.startsWith('_')).map(([k,v])=>`${k}: ${v}`).join(' · ');
      /* T28: Thumbnail 64 px -> quadratisch 160 px statt Originalgroesse laden */
      const thumb = it.image ? it.image + (it.image.indexOf('?')>-1?'&':'?') + 'width=160&height=160&crop=center' : '';
      return `<div class="cart-item">
        <div class="ci-thumb">${thumb?`<img src="${thumb}" alt="" width="64" height="64" style="width:100%;height:100%;object-fit:cover;border-radius:12px">`:(window.BP?BP.icon('Leine'):'')}</div>
        <div class="ci-main">
          <div class="ci-name">${it.product_title}</div>
          ${it.variant_title && it.variant_title!=='Default Title'?`<div class="ci-meta">${it.variant_title}</div>`:''}
          ${props?`<div class="ci-meta">${props}</div>`:''}
          <div class="ci-row">
            <div class="ci-qty"><button data-line="${idx+1}" data-q="${it.quantity-1}">-</button><span>${it.quantity}</span><button data-line="${idx+1}" data-q="${it.quantity+1}">+</button></div>
            <div class="ci-price">${fmt(it.final_line_price)}</div>
          </div>
          <button class="ci-remove" data-line="${idx+1}" aria-label="${it.product_title} aus dem Warenkorb entfernen">✕ Entfernen</button>
        </div>
      </div>`;
    }).join('');

    /* v5.1: Add-on-Karten mit HINZUFUEGEN-Button */
    const inCart = new Set(currentCart.items.map(i=>i.product_id));
    const recs = (addons||[]).filter(a=>!inCart.has(a.pid)).slice(0,3);
    if(recs.length){
      html += `<div class="cart-addons"><div class="ca-head">Schnapp dir noch was Feines 🐾</div><div class="ca-grid">` +
        recs.map(a=>`<div class="ca-card">${a.img?`<img src="${a.img}" alt="" loading="lazy">`:`<div class="ca-noimg">🐾</div>`}<div class="ca-info"><div class="ca-name">${a.title}</div><div class="ca-price">${fmt(a.price)}</div></div><button class="ca-add" data-vid="${a.vid}">Hinzufügen</button></div>`).join('') +
        `</div></div>`;
    }
    body.innerHTML = html;

    const free = currentCart.total_price >= 5000;
    foot.innerHTML = `
      <div class="cart-sub"><span>Zwischensumme</span><strong>${fmt(currentCart.total_price)}</strong></div>
      <div class="cart-ship">${free?'✓ Gratis Versand inklusive':'Noch '+fmt(5000-currentCart.total_price)+' bis zum Gratis-Versand'}</div>
      <a class="btn btn-primary btn-block" href="/checkout">Zur Kasse · ${fmt(currentCart.total_price)}</a>
      <button class="btn btn-light btn-block" id="cartCont">Weiter stöbern</button>`;
    body.querySelectorAll('.ci-qty button').forEach(b=>b.addEventListener('click',()=>updateLine(+b.dataset.line, +b.dataset.q)));
    body.querySelectorAll('.ci-remove').forEach(b=>b.addEventListener('click',()=>{ b.disabled = true; b.textContent='…'; updateLine(+b.dataset.line, 0); }));
    body.querySelectorAll('.ca-add').forEach(b=>b.addEventListener('click',()=>{ b.disabled = true; b.textContent='…'; addVariant(+b.dataset.vid, 1); }));
    document.getElementById('cartCont').addEventListener('click', close);
  }

  function open(){ ensure();
    document.getElementById('cartDrawer').classList.add('open');
    document.getElementById('cartScrim').classList.add('open');
    document.body.style.overflow='hidden';
    fetchCart();
  }
  function close(){ if(!chrome) return;
    document.getElementById('cartDrawer').classList.remove('open');
    document.getElementById('cartScrim').classList.remove('open');
    document.body.style.overflow='';
  }

  return { open, close, addVariant, fetchCart, refresh, openDrawer: open };
})();
window.BPCart = BPCart;

function wireReadMore(){
  var mq = window.matchMedia('(max-width: 820px)');
  var items = Array.prototype.slice.call(document.querySelectorAll('.js-readmore'));
  if(!items.length) return;
  function ensureBtn(el){
    if(el.__rmBtn) return el.__rmBtn;
    var btn = document.createElement('button');
    btn.type='button'; btn.className='rm-toggle'; btn.textContent='Mehr erfahren';
    btn.setAttribute('aria-expanded','false');
    el.parentNode.insertBefore(btn, el.nextSibling);
    btn.addEventListener('click', function(){
      if(el.classList.contains('rm-collapsed')){
        el.classList.remove('rm-collapsed');
        el.style.maxHeight = (el.__rmFull||el.scrollHeight) + 'px';
        btn.textContent='Weniger anzeigen'; btn.setAttribute('aria-expanded','true');
      } else {
        el.classList.add('rm-collapsed');
        el.style.maxHeight = Math.round((el.__rmFull||el.scrollHeight)/2) + 'px';
        btn.textContent='Mehr erfahren'; btn.setAttribute('aria-expanded','false');
      }
    });
    el.__rmBtn = btn; return btn;
  }
  function collapse(el){
    el.classList.remove('rm-collapsed'); el.style.maxHeight='';
    var full = el.scrollHeight;
    if(full < 200){ if(el.__rmBtn) el.__rmBtn.hidden=true; return; }
    el.__rmFull = full;
    el.classList.add('rm-collapsed');
    el.style.maxHeight = Math.round(full/2)+'px';
    var b=ensureBtn(el); b.hidden=false; b.textContent='Mehr erfahren'; b.setAttribute('aria-expanded','false');
  }
  function reset(el){ el.classList.remove('rm-collapsed'); el.style.maxHeight=''; if(el.__rmBtn) el.__rmBtn.hidden=true; }
  function apply(){ items.forEach(function(el){ if(mq.matches) collapse(el); else reset(el); }); }
  apply();
  if(mq.addEventListener) mq.addEventListener('change', apply); else if(mq.addListener) mq.addListener(apply);
}

document.addEventListener('DOMContentLoaded', ()=>{
  wireNav();
  wireReadMore();
  const cb = document.getElementById('cartBtn');
  if(cb) cb.addEventListener('click', e=>{ e.preventDefault(); BPCart.open(); });
  BPCart.fetchCart();
});

/* Produktkarten-Hover (Ben 2026-08-30 / Theme-Migration 2026-09-13): Hover zeigt Bild 2 (data-hover), bei Maus-weg wieder Bild 1.
   T13 (2026-10-09): alt wechselt mit (data-hover-alt), falls vorhanden */
(function(){function bind(){document.querySelectorAll('.prod-card img[data-hover]').forEach(function(img){if(img.__hv)return;img.__hv=1;var o=img.getAttribute('src'),h=img.getAttribute('data-hover'),oa=img.getAttribute('alt'),ha=img.getAttribute('data-hover-alt');if(!h||h===o)return;var c=img.closest('.prod-card')||img.parentNode;c.addEventListener('mouseenter',function(){img.setAttribute('src',h);if(ha)img.setAttribute('alt',ha);});c.addEventListener('mouseleave',function(){img.setAttribute('src',o);if(ha)img.setAttribute('alt',oa);});});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bind);else bind();window.BPCardHoverBind=bind;})();

/* Produktkarten „+ Warenkorb“ (T15/T26, 2026-10-09): Button ohne <form action=/cart/add>, ausserhalb des Karten-Links.
   Ein Listener fuer alle Karten, auch spaeter eingefuegte (Karussell, Empfehlungen). */
document.addEventListener('click', function(e){
  var b = e.target.closest && e.target.closest('.card-add');
  if(!b || !window.BPCart) return;
  e.preventDefault(); e.stopPropagation();
  if(b.disabled) return;
  b.disabled = true;
  Promise.resolve(BPCart.addVariant(+b.getAttribute('data-vid'), 1, {})).catch(function(){}).then(function(){ b.disabled = false; });
});
